import { SaveOutlined } from '@ant-design/icons';
import { Button, Card, Form, message, Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    md: { span: 24 },
    lg: { span: 12 }
  },
  wrapperCol: {
    xs: { span: 24 },
    md: { span: 24 },
    lg: { span: 12 }
  }
};

const getLabel = (field) => {
  switch (field) {
    case 'sebaot_codigo_agente':
      return 'Código de agente';
    case 'sebaot_codigo_cobrador':
      return 'Código de cobrador';
    case 'corredora':
      return 'Corredora';
    default:
      return field;
  }
};

const ConfiguracioinCodigoAgente = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [agentes, setAgentes] = useState([]);
  const [cobradores, setCobradores] = useState([]);
  const [corredoras, setCorredoras] = useState([]);
  const {
    params: { id: idAseguradora }
  } = useRouteMatch();

  const onFinish = async () => {
    const datos = { ...form.getFieldsValue() };
    update(datos);
  };

  const update = async ({
    corredora,
    sebaot_codigo_agente,
    sebaot_codigo_cobrador
  }) => {
    try {
      setLoading(true);
      await instanceRef.instance.put(`aseguradoracorredora/${corredora}`, {
        sebaot_codigo_agente: sebaot_codigo_agente || '',
        sebaot_codigo_cobrador: sebaot_codigo_cobrador || ''
      });
      message.success('Corredora actualizada correctamente');

      const index = corredoras.findIndex((element) => element.id === corredora);

      const nuevaLista = [...corredoras];
      nuevaLista[index].sebaot_codigo_agente = sebaot_codigo_agente;
      nuevaLista[index].sebaot_codigo_cobrador = sebaot_codigo_cobrador;
      setCorredoras(nuevaLista);
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const onChangeCorredora = async (e) => {
    if (e) {
      const corredora = corredoras.find((element) => element.id === e);
      form.setFieldsValue({
        sebaot_codigo_agente: corredora.sebaot_codigo_agente,
        sebaot_codigo_cobrador: corredora.sebaot_codigo_cobrador
      });
    } else {
      form.setFieldsValue({
        sebaot_codigo_agente: null,
        sebaot_codigo_cobrador: null
      });
    }
  };

  useEffect(() => {
    if (idAseguradora) {
      const loadData = async () => {
        setLoading(true);
        const response2 = await instanceRef.instance.get(
          `aseguradoracorredora/${idAseguradora}`
        );
        setCorredoras(response2.data.data.rows || []);

        const agentesCobradores = await instanceRef.instance.get(
          `sebaot/consultar-agentes-cobradores?idAseguradora=${idAseguradora}`
        );

        if (agentesCobradores.data.data) {
          setAgentes(agentesCobradores.data.data.agentes);
          setCobradores(agentesCobradores.data.data.cobradores);
        }

        setLoading(false);
      };
      loadData();
    }
  }, [idAseguradora]);

  return (
    <ResponsiveContainer size="large">
      <Card title="Configuración de Corredoras" style={{ textAlign: 'left' }}>
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <Form
            {...formItemLayout}
            form={form}
            name="corredoras"
            autoComplete="off"
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              label={getLabel('corredora')}
              name="corredora"
              rules={[
                {
                  required: true
                }
              ]}
            >
              <Select
                showSearch
                allowClear
                onChange={(e) => onChangeCorredora(e)}
                // onClear={(e) => onChangeCorredora(e)}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Seleccionar Corredora"
              >
                {corredoras.map((corredora) => (
                  <Option key={corredora.id} value={corredora.id}>
                    {`${corredora.descripcion}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <>
                  <Form.Item
                    label={getLabel('sebaot_codigo_agente')}
                    name="sebaot_codigo_agente"
                    rules={[
                      {
                        whitespace: true
                      }
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Agente"
                      disabled={!form.getFieldValue('corredora')}
                    >
                      {agentes.map((item) => (
                        <Option key={`${item.codigo}`} value={`${item.codigo}`}>
                          {`${item.codigo} - ${item.nombre} - Matrícula (${item.matricula})`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label={getLabel('sebaot_codigo_cobrador')}
                    name="sebaot_codigo_cobrador"
                    // disabled={!form.getFieldValue('corredora')}
                    // readOnly={!form.getFieldValue('corredora')}
                    rules={[
                      {
                        whitespace: true
                      }
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Cobrador"
                      disabled={!form.getFieldValue('corredora')}
                    >
                      {cobradores.map((item) => (
                        <Option key={`${item.codigo}`} value={`${item.codigo}`}>
                          {`${item.codigo} - ${item.nombre}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              )}
            </Form.Item>
            <br />
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Actualizar
            </Button>
          </Form>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default ConfiguracioinCodigoAgente;
